import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Inventory from './views/Inventory.vue'
import Users from './views/Users.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: Inventory
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    }
  ]
})
